import DistributionListFilterContainer from './container';

export default DistributionListFilterContainer;
